import { useForm, Controller } from 'react-hook-form';
import { useEffect, useState } from 'react';

//components
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputText } from 'primereact/inputtext';
import { FileUpload } from 'primereact/fileupload';

//api
import { ProjectManagementService } from '../../../service/projectmanagement-service';

const AddAnalysisFile = ({ onAddFileAnalysis, projectId }) => {
  const {
    register,
    handleSubmit,
    setValue,
    control,
    formState: { errors },
  } = useForm();
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileTypeValue, setFileTypeValue] = useState(null);
  const [uploadSuccessMessage, setUploadSuccessMessage] = useState('');
  const [uploadErrorMessage, setUploadErrorMessage] = useState('');
  const [acceptedFileTypes, setAcceptedFileTypes] = useState('');

  const fileTypes = [
    { name: 'PDF', value: 'pdf' },
    { name: 'Markdown', value: 'md' },
  ];

  useEffect(() => {
    if (fileTypeValue === 'pdf') {
      setAcceptedFileTypes('application/pdf');
    } else if (fileTypeValue === 'md') {
      setAcceptedFileTypes('.md');
    } else {
      setAcceptedFileTypes('');
    }
  }, [fileTypeValue]);

  const onFileChange = (event) => {
    if (event.files && event.files.length > 0) {
      setSelectedFile(event.files[0]);
      setUploadSuccessMessage('');
      setUploadErrorMessage('');
    } else {
      setSelectedFile(null);
    }
  };

  const onSubmit = (data) => {
    if (!selectedFile) {
      console.error('Nessun file selezionato.');
      return;
    }
    const formData = new FormData();
    formData.append('project', projectId);
    formData.append('name', data.fileName);
    formData.append('description', data.description || '');
    formData.append('file_type', data.fileType);
    formData.append('file', selectedFile);

    ProjectManagementService.uploadProjectFile(
      projectId,
      formData,
      (response) => {
        console.log('File caricato con successo: ', response);
        setUploadSuccessMessage('File caricato con successo!');
        setUploadErrorMessage('');
        // reset campi dopo caricamento file
        setSelectedFile(null);
        setValue('fileName', '');
        setValue('description', '');
        setValue('fileType', null);
        onAddFileAnalysis();
      },
      (error) => {
        console.error('Errore durante il caricamento del file: ', error);
        setUploadErrorMessage('Errore durante il caricamento del file.');
        setUploadSuccessMessage('');
      }
    );
  };

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        {uploadSuccessMessage && (
          <div
            className="p-message p-message-success"
            style={{ padding: '0.5em' }}
          >
            {uploadSuccessMessage}
          </div>
        )}
        {uploadErrorMessage && (
          <div
            className="p-message p-message-error"
            style={{ padding: '0.5em' }}
          >
            {uploadErrorMessage}
          </div>
        )}
        <div className="p-field addAnalysisFile__InputWrapper">
          <label htmlFor="fileName">Nome File*</label>
          <InputText
            id="fileName"
            {...register('fileName', {
              required: 'Il nome del file è obbligatorio',
            })}
            className={errors.fileName ? 'p-invalid' : ''}
          />
          {errors.fileName && (
            <small className="p-error">{errors.fileName.message}</small>
          )}
        </div>

        <div className="p-field addAnalysisFile__InputWrapper">
          <label htmlFor="description">Descrizione</label>
          <InputTextarea
            id="description"
            {...register('description')}
            rows={3}
            cols={30}
          />
        </div>

        <div className="p-field addAnalysisFile__InputWrapper">
          <label htmlFor="fileType">Tipo di File*</label>
          <Controller
            name="fileType"
            control={control}
            rules={{ required: 'Il tipo di file è obbligatorio' }}
            render={({ field }) => (
              <Dropdown
                id="fileType"
                value={field.value}
                options={fileTypes}
                optionLabel="name"
                optionValue="value"
                onChange={(e) => {
                  field.onChange(e.value);
                  setFileTypeValue(e.value);
                }}
                placeholder="Seleziona il tipo"
                className={errors.fileType ? 'p-invalid' : ''}
              />
            )}
          />
          {errors.fileType && (
            <small className="p-error">{errors.fileType.message}</small>
          )}
        </div>

        <div className="p-field ">
          <FileUpload
            id="fileUpload"
            name="file"
            accept={acceptedFileTypes}
            maxFileSize={1000000}
            onSelect={onFileChange}
            mode="basic"
            chooseLabel="Scegli File*"
            style={{ margin: '0.5rem 0' }}
          />
          {selectedFile && <small>File selezionato: {selectedFile.name}</small>}
          {selectedFile === null && (
            <small className="p-error">Seleziona un file.</small>
          )}
        </div>
        <Button
          label="Carica File"
          type="submit"
          disabled={!selectedFile || Object.keys(errors).length > 0}
          style={{ margin: '2rem 0' }}
        />
      </form>
    </div>
  );
};

export default AddAnalysisFile;
